import React, {useEffect, useState} from "react";
import {Container, Typography} from "@mui/material";
import styles from "../assets/css/blog.module.scss";
import SimilarPosts from "../components/SimilarPosts";
import {useParams} from "react-router-dom";
import {NewsApi} from "../utils/NewsApi";
import configs from '../utils/config.json';
import {useDataState} from "../context/DataContext";
import $ from 'jquery';

const Blog = (props) => {
    const params = useParams();
    const data=useDataState();

    const [state, setState] = useState({title: "", description: "", body: "", img: ""});
    useEffect(() => {
        window.scrollTo(0, 0);
        (async () => {
            await NewsApi.getNews(params.id, (result) => {
                setState({...result.data, img: `${configs.server.Storage}/${result.data.img}`});
                let doc = new DOMParser().parseFromString(result.data.body, "text/xml");
                $("#body").html(doc.firstChild);

                // setTitle(result.data.title);
                // setDescription(result.data.description);
                // setTitle(result.data.title);
                // editorRef.current.setContent(result.data.body);
                // document.getElementById("img1").setAttribute("src", `${configs.server.Storage}/${result.data.img}`);

            }, (error) => {
            });
        })();
    }, [params.id]);
    return <div>
        <div className={styles.container}>
            <Container maxWidth={"md"} component={"div"} className={styles.wrapper}>
                <div>
                    <Typography variant={"h3"} component={"h3"}>
                        {state.title}
                    </Typography>

                    <Typography variant={"h6"} component={"h6"}>
                        {state.description}
                    </Typography>

                    <img src={state.img} alt={""}/>

                    <Typography variant={"body1"} component={"p"} id={"body"} >
                        {/*{state.body}*/}
                    </Typography>


                </div>
            </Container>
        </div>
        <SimilarPosts content={data.state.news.data.slice(0,3)}/>
    </div>;
};

export default Blog;